<template>
  <div>
    <div>
    <div class="white-background list-top-margin">
      <!-- 面包屑导航 -->
      <div class="page-top">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home/Home' }">主页</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span style="color:#000;font-weight:bold;">生产报表</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <!-- 搜索筛选 -->
      <el-form :model="form" class="user-search" label-width="160px" size="small">

        <el-row>
          <el-col :span="6" v-if="'productCode' in colObj2">
            <el-form-item label="产品编号" >
              <el-input size="small" v-model="form.productCode" placeholder="产品编号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'productName' in colObj2">
            <el-form-item label="产品名称">
              <el-input size="small" v-model="form.productName" placeholder="产品名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" v-if="'specs' in colObj2">
            <el-form-item label="产品规格">
              <el-input size="small" v-model="form.specs" placeholder="产品规格" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" v-if="'unit' in colObj2">
            <el-form-item label="产品单位">
              <el-input size="small" v-model="form.unit" placeholder="产品单位" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" class="text-align-right">
            <el-button size="small" type="primary" icon="el-icon-search" @click="getdata">查询</el-button>
            <el-popover
              placement="left-start"
              title="列配置"
              width="200"
              trigger="click"
              v-model="popIshow2"
              >
              <PopoverContentNew :colData="colData2" @done="popDone2" v-if="popIshow2" ></PopoverContentNew>
              <el-button slot="reference" icon="el-icon-s-operation" size="small" class="left-default-margin">关键词配置</el-button>
            </el-popover>
          </el-col>
        </el-row>
        <el-row v-if="!isFold">
          <el-col :span="6" v-if="'orderCode' in colObj2">
            <el-form-item label="工单编号">
              <el-input size="small" v-model="form.orderCode" placeholder="工单编号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'orderPlanNum' in colObj2">
            <el-form-item label="工单计划数">
              <el-input-number
              size="small"
              v-model="form.orderPlanNum"
              placeholder="工单计划数"
              controls-position="right"
              :min="0"
              clearable
              style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'orderStatus' in colObj2">
            <el-form-item label="工单状态">
              <!-- <el-input size="small" v-model="form.orderStatus" placeholder="工单状态" clearable></el-input> -->
              <el-select
                v-model="form.orderStatus"
                clearable
                multiple
                filterable
                placeholder="请选择"
                style="width:100%;"
              >
                <el-option
                  v-for="item in orderStatusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'remark' in colObj2">
            <el-form-item label="工单备注">
              <el-input size="small" v-model="form.remark" placeholder="工单备注" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'planStartTime' in colObj2">
            <el-form-item label="工单计划开始时间">
              <el-date-picker
                v-model="form.planStartTime"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width:100%;"
                :default-time="['00:00:00','23:59:59']">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'planEndTime' in colObj2">
            <el-form-item label="工单计划结束时间">
              <el-date-picker
                v-model="form.planEndTime"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width:100%;"
                :default-time="['00:00:00','23:59:59']">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'actualStartTime' in colObj2">
            <el-form-item label="工单实际开始时间">
              <el-date-picker
                v-model="form.actualStartTime"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width:100%;"
                :default-time="['00:00:00','23:59:59']">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'actualEndTime' in colObj2">
            <el-form-item label="工单实际结束时间">
              <el-date-picker
                v-model="form.actualEndTime"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width:100%;"
                :default-time="['00:00:00','23:59:59']">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'processName' in colObj2">
            <el-form-item label="工序名称">
              <!-- <el-input size="small" v-model="form.processName" placeholder="工序名称" clearable></el-input> -->
              <el-select
                v-model="form.processName"
                  clearable
                  placeholder="请选择"
                  style="width:100%;"
                >
                  <el-option
                    v-for="item in processNameList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  ></el-option>
                </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'processCode' in colObj2">
            <el-form-item label="工序编号">
              <el-input size="small" v-model="form.processCode" placeholder="工序编号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'coefficient' in colObj2">
            <el-form-item label="报工数配比">
              <el-input-number
              size="small"
              v-model="form.coefficient"
              placeholder="报工数配比"
              controls-position="right"
              :min="0"
              clearable
              style="width: 100%;"></el-input-number>
              <!-- <el-input size="small" v-model="form.coefficient" placeholder="报工数配比" clearable></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'taskStatus' in colObj2">
            <el-form-item label="任务状态">
              <!-- <el-input size="small" v-model="form.taskStatus" placeholder="任务状态" clearable></el-input> -->
              <el-select
                v-model="form.taskStatus"
                  clearable
                  placeholder="请选择"
                  style="width:100%;"
                >
                  <el-option
                    v-for="item in orderStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  ></el-option>
                </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'taskPlanStartTime' in colObj2">
            <el-form-item label="任务计划开始时间">
              <el-date-picker
                v-model="form.taskPlanStartTime"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width:100%;"
                :default-time="['00:00:00','23:59:59']">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'taskPlanEndTime' in colObj2">
            <el-form-item label="任务计划结束时间">
              <el-date-picker
                v-model="form.taskPlanEndTime"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width:100%;"
                :default-time="['00:00:00','23:59:59']">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="6" v-if="'taskActualStartTime' in colObj2">
            <el-form-item label="任务实际开始时间">
              <el-date-picker
                v-model="form.taskActualStartTime"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width:100%;"
                :default-time="['00:00:00','23:59:59']">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'taskActualEndTime' in colObj2">
            <el-form-item label="任务实际结束时间">
              <el-date-picker
                v-model="form.taskActualEndTime"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width:100%;"
                :default-time="['00:00:00','23:59:59']">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'taskPlanNum' in colObj2">
            <el-form-item label="任务计划数">
              <el-input-number
              size="small"
              v-model="form.taskPlanNum"
              placeholder="任务计划数"
              controls-position="right"
              :min="0"
              clearable
              style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'name' in colObj2">
            <el-form-item label="生产人员">
              <!-- <el-input size="small" v-model="form.name" placeholder="生产人员" clearable></el-input> -->
              <el-select
                  v-model="form.producerId"
                  clearable
                  placeholder="请选择"
                  style="width:100%;"
                >
                  <el-option
                    v-for="item in workAuthList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'standardEff' in colObj2">
            <el-form-item label="标准效率">
              <el-input size="small" v-model="form.standardEff" placeholder="标准效率" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'actualEff' in colObj2">
            <el-form-item label="实际效率">
              <el-input size="small" v-model="form.actualEff" placeholder="实际效率" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'achievement' in colObj2">
            <el-form-item label="合格率">
              <!--<el-input-number-->
              <!--size="small"-->
              <!--v-model="form.achievement"-->
              <!--placeholder="合格率"-->
              <!--controls-position="right"-->
              <!--:min="0"-->
              <!--clearable-->
              <!--style="width: 100%;"></el-input-number>-->
               <el-input size="small" v-model="form.achievement" placeholder="合格率" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'countNum' in colObj2">
            <el-form-item label="报工数">
              <el-input-number
              size="small"
              v-model="form.countNum"
              placeholder="报工数"
              controls-position="right"
              :min="0"
              clearable
              style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'goodNum' in colObj2">
            <el-form-item label="良品数">
              <el-input-number
              size="small"
              v-model="form.goodNum"
              placeholder="良品数"
              controls-position="right"
              :min="0"
              clearable
              style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>

          <el-col :span="6" v-if="'nongoodNum' in colObj2">
            <el-form-item label="不良品数">
              <el-input-number
              size="small"
              v-model="form.nongoodNum"
              placeholder="不良品数"
              controls-position="right"
              :min="0"
              clearable
              style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'approveTime' in colObj2">
            <el-form-item label="审批时间">
              <el-date-picker
                v-model="form.approveTime"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width:100%;">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <!--<el-col :span="6" v-if="'unit' in colObj2">-->
            <!--<el-form-item label="单位">-->
              <!--<el-input size="small" v-model="form.unit" placeholder="单位" clearable></el-input>-->
            <!--</el-form-item>-->
          <!--</el-col>-->

          <el-col :span="6" v-if="'createTime' in colObj2">
            <el-form-item label="报工时间">
              <el-date-picker
                v-model="form.createTime"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width:100%;">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="6" v-if="'countDuration' in colObj2">
            <el-form-item label="报工时长">
              <el-input size="small" v-model="form.countDuration" placeholder="报工时长" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'countType' in colObj2">
            <el-form-item label="计价方式">
              <!-- <el-input size="small" v-model="form.countType" placeholder="计价方式" clearable></el-input> -->
              <el-select
                  v-model="form.countType"
                  clearable
                  placeholder="请选择"
                  style="width:100%;"
                >
                  <el-option
                    v-for="item in countTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.show"
                  ></el-option>
                </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6" v-if="'salaryUnit' in colObj2">
            <el-form-item label="工资单价">
              <el-input-number
              size="small"
              v-model="form.salaryUnit"
              placeholder="工资单价"
              controls-position="right"
              :min="0"
              clearable
              style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>

          <el-col :span="6" v-if="'estimateSalary' in colObj2">
            <el-form-item label="预计工资">
              <el-input-number
              size="small"
              v-model="form.estimateSalary"
              placeholder="预计工资"
              controls-position="right"
              :min="0"
              clearable
              style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'approveStatus' in colObj2">
            <el-form-item label="审批状态">
              <!-- <el-input size="small" v-model="form.approveStatus" placeholder="审批状态" clearable></el-input> -->
              <el-select
                v-model="form.approveStatus"
                  clearable
                  placeholder="请选择"
                  style="width:100%;"
                >
                  <el-option
                    v-for="item in approveStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  ></el-option>
                </el-select>

            </el-form-item>
          </el-col>

          <el-col :span="6" v-if="'approver' in colObj2">
            <el-form-item label="审批人">
              <el-input size="small" v-model="form.approver" placeholder="审批人" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'creater' in colObj2">
            <el-form-item label="报工创建人">
              <el-input size="small" v-model="form.creater" placeholder="报工创建人" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'updater' in colObj2">
            <el-form-item label="报工修改人">
              <el-input size="small" v-model="form.updater" placeholder="报工修改人" clearable></el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <el-divider><i :class="!isFold?'el-icon-caret-top':'el-icon-caret-bottom'" @click="fold"></i></el-divider>
      </el-form>
    </div>

    <div class="white-background">
        <el-row class="tbl-btn">
          <el-col :span="12" class="tbl-btn-left">
            <el-button size="small" type="success" plain icon="el-icon-s-promotion" @click="exportExcelNew">导出</el-button>
          </el-col>
          <el-col :span="12" style="text-align: right;">
            <el-popover
              placement="left-start"
              title="关键词配置"
              width="200"
              trigger="click"
              v-model="popIshow"
              >
              <PopoverContentNew :colData="colData" @done="popDone" v-if="popIshow" ></PopoverContentNew>
              <el-button slot="reference" icon="el-icon-s-operation" size="small" class="left-default-margin">关键词配置</el-button>
            </el-popover>
          </el-col>
        </el-row>
        <el-table
        ref="tableData"
          size="small"
          :data="listData"
          highlight-current-row
          v-loading="loading"
          stripe
          border
          :header-cell-style="_headerStyle"
          element-loading-text="加载中"
          style="width: 100%;"
          row-key="_id"
          @selection-change="handleTblSelectionChange"
        >
          <el-table-column align="left" type="selection" :reserve-selection="true" width="60"></el-table-column>
          <el-table-column align="left" type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="productCode" label="产品编号" min-width="120" v-if="'productCode' in colObj"></el-table-column>

          <el-table-column prop="productName" label="产品名称" width="120" v-if="'productName' in colObj"></el-table-column>
          <el-table-column prop="specs" label="产品规格" width="100" v-if="'specs' in colObj"></el-table-column>
          <el-table-column prop="unit" label="产品单位" width="90" v-if="'unit' in colObj"></el-table-column>
          <el-table-column prop="orderCode" label="工单编号" min-width="140" v-if="'orderCode' in colObj"></el-table-column>
          <el-table-column prop="orderPlanNum" label="工单计划数" width="90" v-if="'orderPlanNum' in colObj"></el-table-column>
          <el-table-column prop="orderStatus" label="工单状态" width="90" v-if="'orderStatus' in colObj"></el-table-column>
          <el-table-column prop="remark" label="工单备注" width="90" v-if="'remark' in colObj"></el-table-column>
          <el-table-column prop="planStartTime" label="工单计划开始时间" width="140" v-if="'planStartTime' in colObj"></el-table-column>
          <el-table-column prop="planEndTime" label="工单计划结束时间" width="140" v-if="'planEndTime' in colObj"></el-table-column>
          <el-table-column prop="actualStartTime" label="工单实际开始时间" width="140" v-if="'actualStartTime' in colObj"></el-table-column>
          <el-table-column prop="actualEndTime" label="工单实际结束时间" width="140" v-if="'actualEndTime' in colObj"></el-table-column>
          <el-table-column prop="processName" label="工序名称" width="100" v-if="'processName' in colObj"></el-table-column>
          <el-table-column prop="processCode" label="工序编号" width="100" v-if="'processCode' in colObj"></el-table-column>
          <el-table-column prop="coefficient" label="报工数配比" width="90"  v-if="'coefficient' in colObj"></el-table-column>

          <el-table-column prop="taskStatus" label="任务状态" width="90" v-if="'taskStatus' in colObj"></el-table-column>
          <el-table-column prop="taskPlanStartTime" label="任务计划开始时间" width="140" v-if="'taskPlanStartTime' in colObj"></el-table-column>
          <el-table-column prop="taskPlanEndTime" label="任务计划结束时间" width="140" v-if="'taskPlanEndTime' in colObj"></el-table-column>
          <el-table-column prop="taskActualStartTime" label="任务实际开始时间" width="140" v-if="'taskActualStartTime' in colObj"></el-table-column>
          <el-table-column prop="taskActualEndTime" label="任务实际结束时间" width="140" v-if="'taskActualEndTime' in colObj"></el-table-column>
          <el-table-column prop="taskPlanNum" label="任务计划数" width="90" v-if="'taskPlanNum' in colObj"></el-table-column>
          <el-table-column prop="name" label="生产人员" width="140" v-if="'name' in colObj"></el-table-column>
          <el-table-column prop="standardEff" label="标准效率" width="90" v-if="'standardEff' in colObj"></el-table-column>
          <el-table-column prop="actualEff" label="实际效率" width="90" v-if="'actualEff' in colObj">
            <template slot-scope="scope">
              <span v-if="scope.row.countType != '计件'">{{scope.row.actualEff}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="achievement" label="合格率" width="90" v-if="'achievement' in colObj"></el-table-column>
          <el-table-column prop="countNum" label="报工数" width="80" v-if="'countNum' in colObj"></el-table-column>
          <el-table-column prop="goodNum" label="良品数" width="80" v-if="'goodNum' in colObj"></el-table-column>
          <el-table-column prop="nongoodNum" label="不良品数" width="90" v-if="'nongoodNum' in colObj"></el-table-column>
          <el-table-column prop="approveTime" label="审批时间" width="140" v-if="'approveTime' in colObj"></el-table-column>
          <!--<el-table-column prop="unit" label="单位" width="90" v-if="'unit' in colObj"></el-table-column>-->
          <el-table-column prop="createTime" label="报工时间" width="140" v-if="'createTime' in colObj"></el-table-column>
          <el-table-column prop="countDuration" label="报工时长" width="90" v-if="'countDuration' in colObj">
            <template slot-scope="scope">
              <span v-if="scope.row.countType != '计件'">{{scope.row.countDuration}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="countType" label="计价方式" width="90" v-if="'countType' in colObj"></el-table-column>
          <el-table-column prop="salaryUnit" label="工资单价" width="90" v-if="'salaryUnit' in colObj"></el-table-column>
          <el-table-column prop="estimateSalary" label="预计工资" width="90" v-if="'estimateSalary' in colObj"></el-table-column>
          <el-table-column prop="approveStatus" label="审批状态" width="90" v-if="'approveStatus' in colObj"></el-table-column>
          <el-table-column prop="approver" label="审批人" width="90" v-if="'approver' in colObj"></el-table-column>
          <el-table-column prop="creater" label="报工创建人" width="90" v-if="'creater' in colObj"></el-table-column>
          <el-table-column prop="updater" label="报工修改人" width="90" v-if="'updater' in colObj"></el-table-column>

        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="tbl-pagination"></Pagination>
      </div>
      </div>

  </div>
</template>
<script>

import {produceReport,queryAllUserList} from '@/api/business';
import { processGetAll} from '@/api/basicData';

import Pagination from "@/components/Pagination";
import moment from 'moment';
import PopoverContentNew from '@/components/PopoverContentNew'
import {exportDataToExcel,transfer} from '@/utils/util';

export default {
  name: "FinishedProductionMonth",
  components:{
      Pagination,
      PopoverContentNew
  },
  data() {
    return {
      form: {},
      orderStatusList: [
        {
          label: "自制",
          value: "自制"
        },
        {
          label: "外购",
          value: "外购"
        },
        {
          label: "委外",
          value: "委外"
        }
      ],
      isFold: true,
      listData: [],
      loading: false,
      isBatchPrint: false,
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      createProductPanVisible:false,
      isMain:true,
      userData:{},
      editRow:{},
      mode:'',
      sourceList:[{
        label:'自制',
        value:'0'
      },{
        label:'外购',
        value:'1'
      },{
        label:'委外',
        value:'2'
      }],
      setList:[],
      popIshow:false,//控制popover显隐
      colData:[],
      colDataRes:{
        "产品编号":"productCode",
        "产品名称":"productName",
        "产品规格":"specs",
        "产品单位":"unit",
        "工单编号":"orderCode",
        "工单计划数":"orderPlanNum",
        "工单状态":"orderStatus",
        "工单计划开始时间":"planStartTime",
        "工单计划结束时间":"planEndTime",
        "工单实际开始时间":"actualStartTime",
        "工单实际结束时间":"actualEndTime",
        "工单备注":"remark",
        "工序名称":"processName",
        "工序编号":"processCode",
        "报工数配比":"coefficient",
        "任务状态":"taskStatus",
        "任务计划开始时间":"taskPlanStartTime",
        "任务计划结束时间":"taskPlanEndTime",
        "任务实际开始时间":"taskActualStartTime",
        "任务实际结束时间":"taskActualEndTime",
        "任务计划数":"taskPlanNum",
        "生产人员":"name",
        "标准效率":"standardEff",
        "实际效率":"actualEff",
        "合格率":"achievement",
        "报工数":"countNum",
        "良品数":"goodNum",
        "不良品数":"nongoodNum",
        "审批时间":"approveTime",
        // "单位":"unit",
        "报工时间":"createTime",
        "报工时长":"countDuration",
        "计价方式":"countType",
        "工资单价":"salaryUnit",
        "预计工资":"estimateSalary",
        "审批状态":"approveStatus",
        "审批人":"approver",
        "报工创建人":"creater",
        "报工修改人":"updater"
      },
      colObj:{},
      popIshow2:false,
      colData2:[],
      colObj2:{},
      tblSelectionList:[],
      workAuthList: [],
      processNameList: [],
      orderStatusList: [

        {
          label: "执行中",
          value: "执行中"
        },
        {
          label: "已结束",
          value: "已结束"
        },
        {
          label: "已取消",
          value: "已取消"
        }
      ],
      approveStatusList:[

        {
          label: "已审批",
          value: "已审批"
        },
        {
          label: "未审批",
          value: "未审批"
        }
      ],
      countTypeList:[
        {
          label: "计时",
          value: "计时"
        },
        {
          label: "计件",
          value: "计件"
        }
      ]

    };
  },
  created() {
    for(let key in this.colDataRes){
      this.colData.push({label:this.colDataRes[key],value:key,istrue:true});
      this.colObj[this.colDataRes[key]] = key;
      this.colData2.push({label:this.colDataRes[key],value:key,istrue:true});
      this.colObj2[this.colDataRes[key]] = key;
    }
    var userData = window.localStorage.getItem('userdata')
    if(userData){
      this.userData = JSON.parse(userData)
      this.init();
      this.initDict();

    }
  },
  methods: {
    async initDict(){
      let res = await processGetAll(this.userData.factoryId);
      if(res['code'] == 200){
        this.processNameList = res.data.map(function(item){
          return {
            label:item.processName,
            value:item.processCode
          }
        });
      }
      res = await queryAllUserList(this.userData.factoryId);
      if(res['code'] == 200){
        this.workAuthList = res.data.map(function(item){
          return {
            label:item.name + '(' + item.account + ')',
            show:item.name,
            value:item._id,
          }
        });
      }
    },
    exportExcelNew(){
      if(this.tblSelectionList == null || this.tblSelectionList.length == 0){
        this.exportExcel();

        return;
      }
      const header = [
        '产品编号',
        '产品名称',
        '产品规格',
        '产品单位',
        '工单编号',

        '工单计划数',
        '工单状态',
        '工单计划开始时间',
        '工单计划结束时间',
        '工单实际开始时间',
        '工单实际结束时间',
        '工单备注',
        '工序名称',
        '工序编号',
        '报工数配比',
        '任务状态',

        '任务计划开始时间',
        '任务计划结束时间',
        '任务实际开始时间',
        '任务实际结束时间',
        '任务计划数',

        '生产人员',
        '标准效率',
        '实际效率',
        '达标率',

        '报工数',
        '良品数',
        '不良品数',
        '审批时间',
        '单位',
        '报工时间',
        '报工时长',
        '计价方式',
        '工资单价',
        '预计工资',
        '审批状态',
        '审批人',
        '报工创建人',
        '报工修改人',
      ];

      const filterVal = [
        'productCode',
        'productName',
        'specs',
        'unit',
        'orderCode',

        'orderPlanNum',
        'orderStatus',
        'planStartTime',
        'planEndTime',
        'actualStartTime',
        'actualEndTime',
        'remark',
        'processName',
        'processCode',
        'coefficient',
        'taskStatus',

        'taskPlanStartTime',
        'taskPlanEndTime',
        'taskActualStartTime',
        'taskActualEndTime',
        'taskPlanNum',

        'name',
        'standardEff',
        'actualEff',
        'achievement',

        'countNum',
        'goodNum',
        'nongoodNum',
        'approveTime',
        'unit',
        'createTime',
        'countDuration',
        'countType',
        'salaryUnit',
        'estimateSalary',
        'approveStatus',
        'approver',
        'creater',
        'updater',
      ];
      let filterData =JSON.parse(JSON.stringify(this.tblSelectionList));
      let data = filterData.map(v => filterVal.map(j => v[j]));
      exportDataToExcel(data,header,"生产报表");
    },
    popDone:function(options){
      var _this = this
      this.popIshow = false
      if(options.type == 'save'){
        this.colData = JSON.parse(JSON.stringify(options.data));
        this.colObj = {};
        for(let i = 0;i<this.colData.length;i++){
          if(this.colData[i].istrue){
            this.colObj[this.colData[i].label] = this.colObj[this.colData[i].value];
          }
        }
        this.init();
      }
    },
    popDone2:function(options){
      var _this = this
      this.popIshow2 = false
      if(options.type == 'save'){
        this.colData2 = JSON.parse(JSON.stringify(options.data));
        this.colObj2 = {};
        var _form = {};
        for(let i = 0;i<this.colData2.length;i++){
          if(this.colData2[i].istrue){
            this.colObj2[this.colData[i].label] = this.colObj2[this.colData2[i].value];
            _form[this.colData[i].label] = this.form[this.colData[i].label]
          }
        }
        this.form = JSON.parse(JSON.stringify(_form));
        this.init();
      }
    },
    goBack(){
      this.$router.go(-1);
    },
    init(){
      this.search();

    },
    fold() {
      this.isFold = !this.isFold;
    },
    getdata(){
      this.pageparm.currentPage = 1;
      this.pageparm.pageSize = 10;
      this.search();
    },
    search() {
      this.loading = true
      let con = JSON.parse(JSON.stringify(this.form));


      if(this.form.approveTime && this.form.approveTime.length == 2){

        con.approveTime = {
          begin:this.form.approveTime[0] + ' 00:00:00',
          end:this.form.approveTime[1] + ' 23:59:59',
          type:"between",
          data:'time'
        }
      }
      if(this.form.createTime && this.form.createTime.length == 2){
        con.createTime = {
          begin:this.form.createTime[0] + ' 00:00:00',
          end:this.form.createTime[1] + ' 23:59:59',
          type:"between",
          data:'time'
        }
      }
      if(this.form.planStartTime && this.form.planStartTime.length == 2){
        con.planStartTime = {
          begin:this.form.planStartTime[0] + ' 00:00:00',
          end:this.form.planStartTime[1] + ' 23:59:59',
          type:"between",
          data:'time'
        }
      }
      if(this.form.planEndTime && this.form.planEndTime.length == 2){
        con.planEndTime = {
          begin:this.form.planEndTime[0] + ' 00:00:00',
          end:this.form.planEndTime[1] + ' 23:59:59',
          type:"between",
          data:'time'
        }
      }
      if(this.form.actualStartTime && this.form.actualStartTime.length == 2){
        con.actualStartTime = {
          begin:this.form.actualStartTime[0] + ' 00:00:00',
          end:this.form.actualStartTime[1] + ' 23:59:59',
          type:"between",
          data:'time'
        }
      }
      if(this.form.actualEndTime && this.form.actualEndTime.length == 2){
        con.actualEndTime = {
          begin:this.form.actualEndTime[0] + ' 00:00:00',
          end:this.form.actualEndTime[1] + ' 23:59:59',
          type:"between",
          data:'time'
        }
      }
      if(this.form.taskPlanStartTime && this.form.taskPlanStartTime.length == 2){
        con.taskPlanStartTime = {
          begin:this.form.taskPlanStartTime[0] + ' 00:00:00',
          end:this.form.taskPlanStartTime[1] + ' 23:59:59',
          type:"between",
          data:'time'
        }
      }
      if(this.form.taskPlanEndTime && this.form.taskPlanEndTime.length == 2){
        con.taskPlanEndTime = {
          begin:this.form.taskPlanEndTime[0] + ' 00:00:00',
          end:this.form.taskPlanEndTime[1] + ' 23:59:59',
          type:"between",
          data:'time'
        }
      }


      if(this.form.taskActualStartTime && this.form.taskActualStartTime.length == 2){
        con.taskActualStartTime = {
          begin:this.form.taskActualStartTime[0] + ' 00:00:00',
          end:this.form.taskActualStartTime[1] + ' 23:59:59',
          type:"between",
          data:'time'
        }
      }
      if(this.form.taskActualEndTime && this.form.taskActualEndTime.length == 2){
        con.taskActualEndTime = {
          begin:this.form.taskActualEndTime[0] + ' 00:00:00',
          end:this.form.taskActualEndTime[1] + ' 23:59:59',
          type:"between",
          data:'time'
        }
      }

      var data = {
        condition: con,
        currentPage: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
      }
      data.condition.factoryId=this.userData.factoryId;
      this.listData = [];
      produceReport(data).then(res => {
        this.loading = false;
        if(res.code == 200){
          this.pageparm = res.data;
          this.listData = res.data.list
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    /**
     * 监听表格选中项变化事件
     */
    handleTblSelectionChange(val) {
      this.tblSelectionList = val;
    },



     // 分页插件事件
    callFather(parm) {
      this.pageparm.currentPage = parm.currentPage;
      this.pageparm.pageSize = parm.pageSize;
      this.search();
    },
    exportExcel(){
      //this.loading = true
      var data = {
        condition: this.form,
        type:"生产报表",
        currentPage: 1,
        pageSize: 10000,
      }
      data.condition.factoryId=this.userData.factoryId;
      var x = new XMLHttpRequest();
      var self = this;
      let url = this.$devEnv.API_ROOT + '/report/export';
      x.open("POST", url, true);
      x.responseType = 'blob';
      x.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      x.onload=function(e) {
          if (x.readyState === x.DONE) {
              if (x.status === 200) {
                  //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = "生产报表" + ".xlsx";
                  a.click()
              }else {
                  self.$message({
                      type: 'error',
                      message: '下载失败',
                  });
              }
          }else {
              self.$message({
                  type: 'error',
                  message: '下载失败',
              });
          }
      }
      x.send(JSON.stringify(data));
    },
    productSave(options){
        if(options.type == 'save'){
          this.search()
        }
        this.createProductPanVisible =false;

    },
    viewImportLog(){
      this.isMain = !this.isMain;
    },
    goBack(){
      this.isMain = !this.isMain;
    },
    productFormat(val){
      var res = this.sourceList.filter(function(item){
        return item.value == val.source
      })
      if(res && res.length!=0){
        return res[0].label
      }
    },
  }
};
</script>
<style scoped>
.page-top {
  height: 30px;
  line-height: 30px;
}
.el-breadcrumb {
  line-height: 15px;
}
.page-row {
  /* background-color: #efefef; */
}
.page-row .el-tabs__nav-wrap::after {
  height: 0px;
}
.page-row .el-tabs__header {
  margin: 0px;
}

.user-search {
  margin-top: 20px;
}

.el-divider__text {
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
.tbl-pagination {
  text-align: right;
}
.tbl-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
}
.tbl-btn .tbl-btn-right {
  text-align: right;
}
.el-divider--horizontal {
  margin: 10px 0px;
}
.el-form-item {
  margin-bottom: 20px;
}
.search-row .half-width {
  width: calc(100% - 132px);
  margin-left: 8px;
}
.search-row .input-number {
  width: calc(50% - 5px);
}
</style>



// WEBPACK FOOTER //
// src/views/home/report/FinishedProductionMonth.vue